export default "__VITE_ASSET__a1211d57__"